export enum SESSIONSTORAGE {
	RETRY_LAZY_REFRESHED = 'retry-lazy-refreshed',
}
